import React, { useState } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { ProductCategory, ProductCategoryType } from '@leid/api-products'
import { useRouter } from 'next/navigation'

import Container from 'app/components/shared/Container'
import { convertSerachParamsToURLSearchParams } from 'app/utils/urls'
import { getCategoryName, getCategoryURLParts } from 'components/nav/CategoriesMenu/utils/categories'

import CategoryButton from './components/CategoryButton'

type Props = {
  isBundles: boolean
  searchCategory?: string
  allCategories: ProductCategory[]
  parentCategories?: ProductCategory[]
  queryParams: {
    [key: string]: string | string[] | undefined
  }
  startTransition: (cb: () => void) => void
}

export const BrowseTopBar: React.FC<Props> = ({
  searchCategory,
  isBundles,
  allCategories,
  parentCategories,
  queryParams,
  startTransition,
}) => {
  const router = useRouter()

  const getSelectedCategoryId = (): number | undefined => {
    if (isBundles) {
      if (searchCategory) {
        const selectedCategory = allCategories.find((s) => getCategoryName(s) === searchCategory)
        return selectedCategory?.id
      }
    } else {
      if (parentCategories) {
        const selectedCategory = allCategories.find((s) => parentCategories.some((x) => x.id === s.id))
        return selectedCategory?.id
      }
    }

    return undefined
  }

  const [selectedCategory, setSelectedCategory] = useState(getSelectedCategoryId())

  const categoriesToShow = allCategories.filter(
    (s) => s.parentCategoryId === undefined && s.type === ProductCategoryType.FUNCTIONS,
  )

  const handleSelectCategory = (category: ProductCategory) => {
    setSelectedCategory(category.id)

    // We want to clear search term on category change
    queryParams.searchTerm = undefined
    queryParams.page = undefined
    queryParams.location = undefined
    queryParams.manager = undefined

    if (isBundles) {
      const categoryLink = getCategoryName(category)
      const newCategoryQueryName = categoryLink === searchCategory ? '' : categoryLink

      queryParams.category = newCategoryQueryName

      const params = convertSerachParamsToURLSearchParams(queryParams)
      startTransition(() => {
        router.push(`/bundles?${params.toString()}`)
      })
    } else {
      const url = selectedCategory !== category.id ? `/${getCategoryURLParts(category, allCategories)}` : ''

      const params = convertSerachParamsToURLSearchParams(queryParams)
      startTransition(() => {
        router.push(`/browse${url}?${params.toString()}`)
      })
    }
  }

  return (
    <Box display={{ base: 'none', md: 'block' }} backgroundColor="green.a200" padding="12px 0">
      <Container>
        <Flex
          justifyContent={['flex-start', null, null, 'space-between']}
          as="ul"
          alignItems="center"
          flexWrap={['wrap', null, null, 'nowrap']}
          gap={2}
        >
          {categoriesToShow.map((category, index) => (
            <Box as="li" listStyleType="none" onClick={() => handleSelectCategory(category)} key={index}>
              <CategoryButton isCategorySelected={selectedCategory === category.id}>
                {getCategoryName(category)}
              </CategoryButton>
            </Box>
          ))}
        </Flex>
      </Container>
    </Box>
  )
}
